import React from 'react';
import { Col, DatePicker, Form, Input, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { TimePicker } from 'antd/es';

const FourthSection = ({ isView }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('ACCESSO AUTOMEZZI')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Tipologia automezzo (modello)')} name='car_type'>
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item
          label={t('Portata automezzo ( portata quintali x camion)')}
          name='center_capacity'
        >
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>

      <Col offset={6} span={9}>
        <Form.Item label={t('Targa')} name='vehicle_number'>
          <Input disabled={isView} placeholder={'Inserisci testo'} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Conducente')} name='driver'>
          <Input disabled={isView} placeholder={'Inserisci testo'} />
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item label={t('Telefono di contatto')} name='driver_contact'>
          <Input
            disabled={isView}
            type={'phone'}
            placeholder={'Inserisci testo'}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(FourthSection);
